import { Users } from 'models/UserCollection';
import { Settings } from 'components/Settings';
import { MatchSounds } from 'components/MatchSounds';
import { Request } from 'components/Request';

export const SHOW_SUB_HYPE = 'SHOW_SUB_HYPE';
export const DISMISS_SUB_HYPE = 'DISMISS_SUB_HYPE';
export const LATEST_SUBSCRIBERS_UPDATE = 'LATEST_SUBSCRIBERS_UPDATE';
export const TOP_DONATORS_UPDATE = 'TOP_DONATORS_UPDATE';
export const NEWEST_SUBSCRIBERS_UPDATE = 'NEWEST_SUBSCRIBERS_UPDATE';
export const LATEST_DONATORS_UPDATE = 'LATEST_DONATORS_UPDATE';
export const TOP_GIFTERS_UPDATE = 'TOP_GIFTERS_UPDATE';
export const MOST_DISPUTES_UPDATE = 'MOST_DISPUTES_UPDATE';

export const NEXT_DISPLAYED_SUBLIST = 'NEXT_DISPLAYED_SUBLIST';
export const SET_SUB_LISTS = 'SET_SUB_LISTS';

let autoDismissTimeout = null;

export const nextDisplayedSubList = (e) => {
	if(e) {
		e.preventDefault();
	}
	return {
		type: NEXT_DISPLAYED_SUBLIST
	};
};

export const setSubLists = (subLists) => {
	const serialized = [];
	_.each(subLists, (item, index) => {

		if(Array.isArray(item)) {
			let innerIndex = 0;
			for(let staticItem of item) {
				serialized.push({
					index: index,
					type: 'static',
					innerIndex: innerIndex
				});
				innerIndex++;
			}
		}
		else {
			serialized.push({
				index,
				type: item.type,
			});
		}
	});
	return {
		type: SET_SUB_LISTS,
		payload: serialized
	};
};

export const showSubHype = (hype) => (dispatch) => {
	const user = Users.update(hype.user);

	let playSound = hype.play_sound || hype.is_super_hype;
	if(hype.type === 'subscription') {
		playSound = true;
		user.update({ is_subscribed: true });

	}

	if(!Settings.isChecked('sub_hype_notification_sound')) {
		playSound = false;
	}
	if(playSound) {
		if(hype.is_super_hype === 2){
			MatchSounds.playSubHypeSoundEffect('thumped');
		}
		else if(hype.amount >= 50 || hype.is_super_hype) {
			MatchSounds.playSubHypeSoundEffect('bumped');
		}
		else {
			MatchSounds.playSubHypeSoundEffect();
		}
	}

	clearTimeout(autoDismissTimeout);

	autoDismissTimeout = setTimeout(() => {
		dispatch(dismissSubHype());
	}, 30000);
	dispatch({
		type: SHOW_SUB_HYPE,
		payload: hype
	});
};

export const dismissSubHype = () => {
	return {
		type: DISMISS_SUB_HYPE
	};
};

export const topDonatorsUpdate = (topDonators) => {
	return {
		type: TOP_DONATORS_UPDATE,
		payload: topDonators
	};
};

export const latestSubscribersUpdate = (latestSubscribers) => {
	return {
		type: LATEST_SUBSCRIBERS_UPDATE,
		payload: latestSubscribers
	};

};
export const newestSubscribersUpdate = (newestSubscribers) => {
	return {
		type: NEWEST_SUBSCRIBERS_UPDATE,
		payload: newestSubscribers
	};
};
export const topGiftersUpdate = (topGifters) => {
	return {
		type: TOP_GIFTERS_UPDATE,
		payload: topGifters
	};
};
export const latestDonatorsUpdate = (latestDonators) => {
	return {
		type: LATEST_DONATORS_UPDATE,
		payload: latestDonators
	};
};

export const mostDisputes = (mostDisputes) => {
	return {
		type: MOST_DISPUTES_UPDATE,
		payload: mostDisputes
	};
};

// The sidebar lists in greatest_subs: from site/supporters, or pushed over the
// socket when someone subscribes.
export const greatestSubsUpdate = (greatestSubs) => (dispatch) => {
	if(greatestSubs.latest_subscribers) {
		dispatch(latestSubscribersUpdate(greatestSubs.latest_subscribers));
	}
	if(greatestSubs.top_donators) {
		dispatch(topDonatorsUpdate(greatestSubs.top_donators));
	}
	if(greatestSubs.newest_subscribers) {
		dispatch(newestSubscribersUpdate(greatestSubs.newest_subscribers));
	}
	if(greatestSubs.latest_donators) {
		dispatch(latestDonatorsUpdate(greatestSubs.latest_donators));
	}
	if(greatestSubs.top_gifters) {
		dispatch(topGiftersUpdate(greatestSubs.top_gifters));
	}
};

// The lists are the same for every user, so the sidebar requests them itself
// instead of startup waiting on them.
export const loadSupporters = () => (dispatch) => Request.apiv1Get('site/supporters')
	.then((response) => {
		if(response.greatest_subs) {
			dispatch(greatestSubsUpdate(response.greatest_subs));
		}
		if(response.dispute_destroyers) {
			dispatch(mostDisputes(response.dispute_destroyers));
		}
	})
	.catch((error) => {
		console.error('Could not load the supporter lists', error);
	});
